module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"eservices":"EServices","dfm-ir":"DFM IR","market":"Market","marketstatus":["closed","open","preopen","preclose"]},"ar":{"eservices":"الخدمات الإلكترونية","dfm-ir":"علاقات المستثمرين","market":"السوق","marketstatus":["مغلق","مفتوح","قبل الافتتاح","قبل الإغلاق"]}}')
  delete Component.options._Ctor
}
